/**
 * Sales Rep Locator — Interactive Search & Filter
 * Vanilla JS, no dependencies.
 */
(function () {
  'use strict';

  /* ========================
     STATE NAME → ABBREVIATION MAP
     ======================== */
  var STATE_MAP = {
    'alabama':'AL','alaska':'AK','arizona':'AZ','arkansas':'AR','california':'CA',
    'colorado':'CO','connecticut':'CT','delaware':'DE','district of columbia':'DC',
    'florida':'FL','georgia':'GA','hawaii':'HI','idaho':'ID','illinois':'IL',
    'indiana':'IN','iowa':'IA','kansas':'KS','kentucky':'KY','louisiana':'LA',
    'maine':'ME','maryland':'MD','massachusetts':'MA','michigan':'MI','minnesota':'MN',
    'mississippi':'MS','missouri':'MO','montana':'MT','nebraska':'NE','nevada':'NV',
    'new hampshire':'NH','new jersey':'NJ','new mexico':'NM','new york':'NY',
    'north carolina':'NC','north dakota':'ND','ohio':'OH','oklahoma':'OK','oregon':'OR',
    'pennsylvania':'PA','rhode island':'RI','south carolina':'SC','south dakota':'SD',
    'tennessee':'TN','texas':'TX','utah':'UT','vermont':'VT','virginia':'VA',
    'washington':'WA','west virginia':'WV','wisconsin':'WI','wyoming':'WY',
    'puerto rico':'PR','canada':'CANADA','caribbean':'CARIBBEAN'
  };

  /* ========================
     DOM REFERENCES
     ======================== */
  var searchInput = document.getElementById('rep-locator-search');
  var clearBtn = document.getElementById('rep-locator-clear');
  var grid = document.getElementById('rep-locator-grid');
  var heading = document.getElementById('rep-locator-results-heading');
  var countEl = document.getElementById('rep-locator-results-count');
  var emptyEl = document.getElementById('rep-locator-empty');
  var resultsSection = document.getElementById('rep-locator-results');

  if (!searchInput || !grid) return;

  var repCards = grid.querySelectorAll('.rep-locator-card');
  var directorCards = grid.querySelectorAll('.rep-locator-director-card');
  var cards = grid.querySelectorAll('.rep-locator-card, .rep-locator-director-card');
  var pills = document.querySelectorAll('.rep-locator-region-pill');

  var activeRegion = null;

  /* ========================
     HELPERS
     ======================== */

  /**
   * Resolve a search term to possible state abbreviations.
   * Returns an array of abbreviation strings to match against territory.
   */
  function resolveStateAbbreviations(term) {
    var lower = term.toLowerCase().trim();
    var abbrevs = [];

    // Direct abbreviation match (2-letter input)
    if (lower.length === 2) {
      abbrevs.push(lower.toUpperCase());
    }

    // Full state name match
    if (STATE_MAP[lower]) {
      abbrevs.push(STATE_MAP[lower]);
    }

    // Partial state name match (e.g., "flor" matches "florida" → "FL")
    if (lower.length >= 3) {
      for (var stateName in STATE_MAP) {
        if (STATE_MAP.hasOwnProperty(stateName) && stateName.indexOf(lower) === 0) {
          abbrevs.push(STATE_MAP[stateName]);
        }
      }
    }

    return abbrevs;
  }

  /**
   * Check if a territory string contains the given abbreviation.
   * Handles formats like "FL", "TX, LA", "NY (Upstate)", "ID (Southern)".
   */
  function territoryContainsAbbrev(territory, abbrev) {
    // Special handling for non-US territories
    if (abbrev === 'CANADA') {
      return territory.toLowerCase().indexOf('canada') > -1;
    }
    if (abbrev === 'CARIBBEAN') {
      return territory.toLowerCase().indexOf('caribbean') > -1;
    }

    // Match abbreviation as a word boundary in the territory string
    // E.g., "IN" should match "IN," or "IN " or "IN (" but not "INC" inside a name
    var re = new RegExp('\\b' + abbrev + '\\b', 'i');
    return re.test(territory);
  }

  function updateCount() {
    var visible = 0;
    for (var i = 0; i < repCards.length; i++) {
      if (!repCards[i].hidden) visible++;
    }
    var visibleDirectors = 0;
    for (var i = 0; i < directorCards.length; i++) {
      if (!directorCards[i].hidden) visibleDirectors++;
    }

    var total = visible + visibleDirectors;
    countEl.textContent = total + ' result' + (total !== 1 ? 's' : '') + ' found';

    if (total === 0) {
      emptyEl.style.display = '';
    } else {
      emptyEl.style.display = 'none';
    }
  }

  function setHeading(text) {
    heading.textContent = text;
  }

  function showClear(show) {
    clearBtn.style.display = show ? '' : 'none';
  }

  function deactivateAllPills() {
    for (var i = 0; i < pills.length; i++) {
      pills[i].classList.remove('active');
      pills[i].setAttribute('aria-pressed', 'false');
    }
    activeRegion = null;
  }

  function showAllCards() {
    for (var i = 0; i < repCards.length; i++) {
      repCards[i].hidden = false;
    }
    for (var i = 0; i < directorCards.length; i++) {
      directorCards[i].hidden = false;
    }
  }

  function resetAll() {
    searchInput.value = '';
    deactivateAllPills();
    showAllCards();
    setHeading('All Representatives');
    showClear(false);
    updateCount();
  }

  /* ========================
     SEARCH HANDLER
     ======================== */
  function handleSearch() {
    var term = searchInput.value.trim();

    // Clear region filter when searching
    if (term.length > 0) {
      deactivateAllPills();
      showClear(true);
    } else {
      showClear(false);
    }

    if (term.length === 0) {
      showAllCards();
      setHeading('All Representatives');
      updateCount();
      return;
    }

    var lowerTerm = term.toLowerCase();
    var stateAbbrevs = resolveStateAbbreviations(term);

    setHeading('Search Results');

    var searchPhone = lowerTerm.replace(/[-() ]/g, '');

    for (var i = 0; i < repCards.length; i++) {
      var card = repCards[i];
      var name = (card.getAttribute('data-name') || '').toLowerCase();
      var territory = card.getAttribute('data-territory') || '';
      var phone = (card.getAttribute('data-phone') || '').replace(/[-() ]/g, '');
      var region = (card.getAttribute('data-region') || '').toLowerCase();
      var principal = (card.getAttribute('data-principal') || '').toLowerCase();

      var match = false;

      if (name.indexOf(lowerTerm) > -1) match = true;
      if (!match && principal.indexOf(lowerTerm) > -1) match = true;
      if (!match && region.indexOf(lowerTerm) > -1) match = true;
      if (!match && territory.toLowerCase().indexOf(lowerTerm) > -1) match = true;
      if (!match && searchPhone.length >= 3 && phone.indexOf(searchPhone) > -1) match = true;

      if (!match && stateAbbrevs.length > 0) {
        for (var j = 0; j < stateAbbrevs.length; j++) {
          if (territoryContainsAbbrev(territory, stateAbbrevs[j])) {
            match = true;
            break;
          }
        }
      }

      card.hidden = !match;
    }

    // Filter director cards by name or region
    for (var i = 0; i < directorCards.length; i++) {
      var card = directorCards[i];
      var name = (card.getAttribute('data-name') || '').toLowerCase();
      var region = (card.getAttribute('data-region') || '').toLowerCase();

      var match = false;
      if (name.indexOf(lowerTerm) > -1) match = true;
      if (!match && region.indexOf(lowerTerm) > -1) match = true;

      card.hidden = !match;
    }

    updateCount();
  }

  /* ========================
     REGION FILTER HANDLER
     ======================== */
  function handleRegionClick(e) {
    var pill = e.currentTarget;
    var regionName = pill.getAttribute('data-region-name');

    // Clear search when filtering by region
    searchInput.value = '';

    // Toggle: if already active, deactivate
    if (activeRegion === regionName) {
      resetAll();
      return;
    }

    // Activate this pill
    deactivateAllPills();
    pill.classList.add('active');
    pill.setAttribute('aria-pressed', 'true');
    activeRegion = regionName;
    showClear(true);

    // Filter rep cards
    for (var i = 0; i < repCards.length; i++) {
      var cardRegion = repCards[i].getAttribute('data-region');
      repCards[i].hidden = (cardRegion !== regionName);
    }

    // Filter director cards
    for (var i = 0; i < directorCards.length; i++) {
      var cardRegion = directorCards[i].getAttribute('data-region');
      directorCards[i].hidden = (cardRegion !== regionName);
    }

    setHeading(regionName + ' Representatives');
    updateCount();

    // Smooth scroll to results
    if (resultsSection) {
      resultsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  /* ========================
     EVENT LISTENERS
     ======================== */
  searchInput.addEventListener('input', handleSearch);

  for (var i = 0; i < pills.length; i++) {
    pills[i].addEventListener('click', handleRegionClick);
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', resetAll);
  }

  // Initial count
  updateCount();

})();
